export default "__VITE_ASSET__DE_KEpbN__"